import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useCallback, useEffect, useState } from 'react';
import classNames from 'classnames/bind';
import { Button, LightningOutlineIcon, Text } from '@beef/ui-kit';
import { ColorPickerSection, NewsSubscribeSection, PriceSection, TypesOptionsSection } from "../common";
import style from "./styles.module.pcss";
var cx = classNames.bind(style);
export var ContentSubscribePreview = function ContentSubscribePreview(_ref) {
  var _device$types;
  var device = _ref.device,
    size = _ref.size,
    isAvailableDevice = _ref.isAvailableDevice,
    subscribeData = _ref.subscribeData,
    onChangeType = _ref.onChangeType,
    onChangeColor = _ref.onChangeColor;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isSubscribed = _useState2[0],
    setIsSubscribed = _useState2[1];
  useEffect(function () {
    setIsSubscribed(!!(subscribeData !== null && subscribeData !== void 0 && subscribeData.isSubscribed));
  }, [subscribeData]);
  var setOpenForm = useCallback(function () {
    setIsSubscribed(false);
    if (subscribeData !== null && subscribeData !== void 0 && subscribeData.onClick) {
      subscribeData.onClick();
    }
  }, [subscribeData]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, (device === null || device === void 0 ? void 0 : device.price) && /*#__PURE__*/React.createElement(PriceSection, {
    device: device,
    isAvailable: isAvailableDevice,
    size: size
  }), /*#__PURE__*/React.createElement(ColorPickerSection, {
    device: device,
    onChangeColor: onChangeColor,
    size: size
  }), !!(device !== null && device !== void 0 && (_device$types = device.types) !== null && _device$types !== void 0 && _device$types.length) && /*#__PURE__*/React.createElement(TypesOptionsSection, {
    onChangeType: onChangeType,
    size: size,
    types: device.types
  }), /*#__PURE__*/React.createElement("div", {
    className: cx('sale-soon-wrapper')
  }, /*#__PURE__*/React.createElement(LightningOutlineIcon, null), /*#__PURE__*/React.createElement(Text, {
    size: "size5-m",
    tagType: "p"
  }, device.promoSaleSoon)), (device === null || device === void 0 ? void 0 : device.promoSaleSoon) && /*#__PURE__*/React.createElement("div", {
    className: cx('promo-sale-soon-wrapper', size && "promo-sale-soon-wrapper--".concat(size))
  }, /*#__PURE__*/React.createElement(Text, {
    size: "size5-r-s"
  }, device.promoSubscribe)), isSubscribed ? /*#__PURE__*/React.createElement("div", {
    className: cx('button-wrapper')
  }, /*#__PURE__*/React.createElement(Button, {
    fullWidth: size === 's',
    onClick: setOpenForm,
    size: subscribeData === null || subscribeData === void 0 ? void 0 : subscribeData.size,
    type: "button",
    variant: subscribeData === null || subscribeData === void 0 ? void 0 : subscribeData.variant
  }, subscribeData === null || subscribeData === void 0 ? void 0 : subscribeData.title)) : /*#__PURE__*/React.createElement(NewsSubscribeSection, {
    personalDataLink: device === null || device === void 0 ? void 0 : device.personalDataLink,
    size: size,
    subscribeData: subscribeData
  }));
};